import React from 'react';
import { ThemeProvider } from '@resideo/blueprint-react';
import lightTheme from 'themes/light';

const ThemePreferencesProvider = ({ children }): JSX.Element => {
  return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>;
};

export default ThemePreferencesProvider;
